export const engagementCampaignsGlobalRateLimitsAppGroupId =
  "/engagement/campaigns/global_rate_limits/:app_group_id";
